import { numberWithSpaces } from "../../../../utilities/formaters";

export function getParts(rows, array) {
  const space = <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>;
  let total = 0;
  if (rows.Principal) {
    total += rows.Principal.Amount;
    array.push(
      <span>
        {space}{" "}
        {"Principal: " + numberWithSpaces(rows.Principal.Amount) + " kr"}
      </span>,
    );
  }
  if (rows.Interest) {
    total += rows.Interest.Amount;
    array.push(
      <span>
        {space} {"Interest: " + numberWithSpaces(rows.Interest.Amount) + " kr"}
      </span>,
    );
  }
  if (rows.IntermediationFee) {
    total += rows.IntermediationFee.Amount;
    array.push(
      <span>
        {space}{" "}
        {"Intermediation Fee: " +
          numberWithSpaces(rows.IntermediationFee.Amount) +
          " kr"}
      </span>,
    );
  }
  if (rows.InvoiceFee) {
    total += rows.InvoiceFee.Amount;
    array.push(
      <span>
        {space}{" "}
        {"Admin Fee: " + numberWithSpaces(rows.InvoiceFee.Amount) + " kr"}
      </span>,
    );
  }
  if (rows.ReminderFee) {
    total += rows.ReminderFee.Amount;
    array.push(
      <span>
        {space}{" "}
        {"Reminder Fee: " + numberWithSpaces(rows.ReminderFee.Amount) + " kr"}
      </span>,
    );
  }
  if (rows.PenaltyFee) {
    total += rows.PenaltyFee.Amount;
    array.push(
      <span>
        {space}{" "}
        {"Penalty Fee: " + numberWithSpaces(rows.PenaltyFee.Amount) + " kr"}
      </span>,
    );
  }

  if (rows.LateFee) {
    total += rows.LateFee.Amount;
    array.push(
      <span>
        {space} {"Late Fee" + numberWithSpaces(rows.LateFee.Amount) + " kr"}
      </span>,
    );
  }

  if (rows.RenewalFee) {
    total += rows.RenewalFee.Amount;
    array.push(
      <span>
        {space}{" "}
        {"Invoice Fee: " + numberWithSpaces(rows.RenewalFee.Amount) + " kr"}
      </span>,
    );
  }
  if (rows.RescheduleFee) {
    total += rows.RescheduleFee.Amount;
    array.push(
      <span>
        {space}{" "}
        {"Reschedule Fee: " +
          numberWithSpaces(rows.RescheduleFee.Amount) +
          " kr"}
      </span>,
    );
  }
  if (rows.CollectionFee) {
    total += rows.CollectionFee.Amount;
    array.push(
      <span>
        {space}{" "}
        {"Collection Fee: " +
          numberWithSpaces(rows.CollectionFee.Amount) +
          " kr"}
      </span>,
    );
  }
  if (rows.KFMFee) {
    total += rows.KFMFee.Amount;
    array.push(
      <span>
        {space} {"KFM Fee: " + numberWithSpaces(rows.KFMFee.Amount) + " kr"}
      </span>,
    );
  }
  if (rows.PpiFee) {
    total += rows.PpiFee.Amount;
    array.push(
      <span>
        {space} {"PPI Fee: " + numberWithSpaces(rows.PpiFee.Amount) + " kr"}
      </span>,
    );
  }
  if (rows.PostTerminationInterest) {
    total += rows.PostTerminationInterest.Amount;
    array.push(
      <span>
        {space}{" "}
        {"Post-term interest: " +
          numberWithSpaces(rows.PostTerminationInterest.Amount) +
          " kr"}
      </span>,
    );
  }
  if (rows.OtherFees) {
    total += rows.OtherFees.Amount;
    array.push(
      <span>
        {space}{" "}
        {"Other Fees: " + numberWithSpaces(rows.OtherFees.Amount) + " kr"}
      </span>,
    );
  }

  return total;
}
